import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { IntlService } from '@sinequa/core/intl';
import { LoginService } from '@sinequa/core/login';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() goToHome;

  userId = '';

  fullName: string | undefined = '';

  private subscriptions: Subscription = new Subscription();

  headerTitle = this.intlService.formatMessage("msg#header.logo");

  constructor(
    private intlService: IntlService,
    private loginService: LoginService) { }

  ngOnInit(): void {

    this.subscriptions.add(this.loginService.events.subscribe(
      (event) => {
        if (event.type === "login-complete") {
          let secondName = this.loginService.principal?.fullName.split(",")[0].charAt(0);
          let firstName = this.loginService.principal?.fullName.split(",")[1].trim().charAt(0);
          this.fullName = this.loginService.principal?.fullName;
          if (firstName && secondName) {
            this.userId = firstName + '' + secondName;
          }
        }
      }))
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.goToHome) {
      this.goToHome = changes.goToHome.currentValue;
      const img = document.querySelectorAll('img');
      const logoName = document.querySelectorAll('p');
      img.forEach(logo => {
        logo.classList.add('show-pointer');
      });
      logoName.forEach(name => {
        name.classList.add('show-pointer');
      })
    }
  }
}
